module.exports = __webpack_public_path__ + "0ef4962fbb2832d750da9949c1757285.xml";